import { useId } from 'react';

export function ActivityBars({ label, days, metric, tone = 'blue' }: {
  label: string; days: Array<{ date: string; accepted: number; replies: number }>;
  metric: 'accepted' | 'replies'; tone?: 'blue' | 'violet';
}) {
  const id = useId();
  const total = days.reduce((sum, point) => sum + point[metric], 0);
  // Both adjacent series use the same baseline and scale.
  const tick = Math.max(1, Math.ceil(Math.max(...days.flatMap(point => [point.accepted, point.replies]), 0) / 5));
  const max = tick * 5;
  const shortDate = (date: string) => new Date(date + 'T00:00:00Z').toLocaleDateString('en-IE', { day: 'numeric', month: 'short', timeZone: 'UTC' });
  return <figure className={'activity-bars activity-bars--' + tone} aria-labelledby={id}>
    <figcaption id={id}>{label}: <strong>{total.toLocaleString()}</strong></figcaption>
    <div className="activity-bars__plot" role="img" aria-label={label + ', ' + total + ' over seven complete UTC days. Exact daily values below.'}>
      <div className="activity-bars__scale" aria-hidden="true">{Array.from({ length: 6 }, (_, index) => <span key={index} style={{ bottom: (index * 20) + '%' }}><small>{index * tick}</small></span>)}</div>
      {days.map(point => <div className="activity-bars__column" key={point.date}>
        <div className="activity-bars__track"><span className="activity-bars__value" style={{ height: (point[metric] / max * 100) + '%' }}><span>{point[metric]}</span></span></div>
        <time className="activity-bars__date" dateTime={point.date} title={shortDate(point.date)}>{Number(point.date.slice(-2))}</time>
      </div>)}
    </div>
    <details className="activity-bars__values"><summary>Daily values</summary><table><caption>{label} by UTC day</caption><tbody>{days.map(point => <tr key={point.date}><th scope="row">{point.date}</th><td>{point[metric]}</td></tr>)}</tbody></table></details>
  </figure>;
}
